import React, { useState, useEffect } from "react";
import "slick-carousel/slick/slick-theme.css";
import "slick-carousel/slick/slick.css";
import EnterImage from "../../../../assets/images/enter 1.png";
import img from "../../../../assets/images/rightSign.png";
import "./LiveMeetUp.css";
import Slider from "react-slick";
import { Link } from "react-router-dom";
import axios from "axios";
import moment from "moment";
import { serverInfo } from "../../../../App";
import { useContext } from "react";

const StarMeetUpEventCompleted = () => {
  const { imageCdnUrl } = useContext(serverInfo);
  const [meetupEvents, setMeetupEvents] = useState([]);
  const [count, setCount] = useState(0);

  // Fetch Stars Added By Admin
  useEffect(() => {
    axios.get(`/api/star/meetup_event/completed`).then((res) => {
      if (res.status === 200) {
        setMeetupEvents(res.data.events);
        setCount(res.data.count);
      }
    });
  }, []);

  return (
    <>
      <div className="AS">
        <div
          title="Live Now"
          className="col-md-2 align-items-center justify-content-center Souvenir-bt "
        >
          <div className="card meetupCard">
            <div className="card-body  align-items-center">
              <center>
                <tr>
                  <td className="ad-card-td">
                    <img
                      src={img}
                      className=""
                      alt="..."
                      style={{ width: "90px" }}
                    />
                  </td>
                  <td className="ad-card-td">
                    <small className="ad-card-small">{count}</small>
                  </td>
                </tr>
              </center>
            </div>
            <button
              className="card-footer Souvenir-button  w-100 "
              data-bs-toggle="collapse"
              data-bs-target="#collapseOne"
              aria-expanded="true"
              aria-controls="collapseOne"
            >
              {" "}
              Completed Meet Up
            </button>
          </div>
        </div>

        <div className="card card-bg mt-3 py-2">
          <div className="d-flex px-4 pt-3">
            <div className="faTrophy">
              <i className="fas fa-trophy"></i>
            </div>
            <h4 className="mx-3 text-white p-2">Completed Meetup Events</h4>
          </div>

          <div className="">
            <div className="slick-parent d-flex justify-content-center">
              {meetupEvents.map((event, index) => (
                <div className="p-3">
                  <div className="completedMeetupBlack">
                    <img
                      src={imageCdnUrl + event.banner}
                      className="img-fluid"
                      alt=""
                      style={{
                        height: "200px",
                        width: "300px",
                      }}
                    />
                    <div className="p-3">
                      <h6 className="text-light">Event Id: {event.id}</h6>
                      <hr></hr>
                      <div className="d-flex justify-content-between">
                        <Link
                          to={`/superstar/meetup-events/details/${event.id}`}
                          className="Link"
                        >
                          <h5 className="text-white text-ellipsis">
                            {event.title}
                          </h5>
                        </Link>
                        <img className="img-fluid" src={EnterImage} alt="" />
                      </div>

                      <p className="text-secondary">
                        {moment(event.date).format("LL")} <br></br>
                        {moment(event.start_time, "HH:mm:ss").format("hh:mm A")}
                        -{moment(event.end_time, "HH:mm:ss").format("hh:mm A")}
                      </p>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default StarMeetUpEventCompleted;
